<template>
  <div class="pt-60 pl-80 pb-84 pr-80">
    <div class="container-1752">
      <div class="bread">
        <span class="cup" @click="handleLinks('/stationed/index')">{{ $t('专家1') }}/</span>
        <span class="active">{{ is_expert ? $t('个人中心') : $t('TA的主页') }}</span>
      </div>

      <div class="df">
        <div class="left-box">
          <div class="card1 pl-48">
            <div class="level-boxs">
              {{ userData.user_points_level }}
            </div>
            <div class="t1">{{ $t('当前等级') }} <span class="s1 mr-16">Lv{{ userData.user_points_level }}</span>
              {{ $t('个人贡献值') }} <span class="s2">{{ userData.user_score }}</span></div>
            <div class="mt-23 imglist df fww">
              <div class="t2">{{ $t('等级勋章') }}</div>
              <div class="ml-4">
                <template v-for="(item, index) in userData.user_logo_arr">
                  <!--                <img :src="require('@/assets/images/grade/sign-' + item)" class="ml-4" alt="">-->
                  <img :src="require('@/assets/images/grade/sign-' + item)" alt="" v-if="!currLanguage">
                  <img :src="require('@/assets/images/grade_en/sign-' + item)" alt="" v-else>
                </template>
                <template v-if="userData.user_medal_arr">
                  <!--                <img :src="require('@/assets/images/grade/level-' + userData.user_medal_arr)" class="ml-4" alt="">-->
                  <img :src="require('@/assets/images/grade/level-' + userData.user_medal + '.png')"
                    v-if="!currLanguage" alt="">
                  <img :src="require('@/assets/images/grade_en/level-' + userData.user_medal + '.png')" v-else alt="">
                </template>
              </div>
            </div>
          </div>

          <!--  -->
          <template v-if="is_expert">
            <div class="card-tab">
              <div class="li" v-for="(item, index) in tabs" :key="index" :class="{ active: activeTab === item.value }"
                @click="setActiveTab(item.value)">
                <span class="iconfont" :class="item.icon"></span>
                <span>{{ $t(item.label) }}</span>
              </div>
            </div>
          </template>

          <!-- 互动 -->
          <div v-if="!is_expert" class="card2">
            <div class="t1">{{ $t('TA的互动') }}</div>

            <div class="interaction-box">
              <template v-if="replyList && replyList.length">
                <div class="list" v-for="(item, index) in replyList" :key="index">
                  <div class="mt-20 df jcsb fww">
                    <div class="df">
                      <template v-if="item.parent.ans_type == 10">
                        <img :src="item.parent.user_avatar_url || defaultAvatar" class="avatar mb-2" alt="用户头像">

                      </template>
                      <template v-else>
                        <img :src="defaultAvatar" class="avatar  mb-2" alt="用户头像">
                      </template>
                      <template v-if="item.parent.ans_type == 20">
                        <span class="name one-text ml-6" style="max-width: 96px;" :title="$t('匿名用户')">{{ $t('匿名用户')
                          }}</span>
                      </template>
                      <template v-else>
                        <span class="name one-text ml-6" style="max-width: 96px;" :title="item.parent.is_expert == 10 ?
          item.parent.user_name :
          item.parent.user_nick_name">{{ item.parent.is_expert == 10 ?
          item.parent.user_name :
          item.parent.user_nick_name }}</span>
                      </template>
                      <span class="d1 ml-8 ">{{ $t('给TA评论') }}</span>
                    </div>
                    <div class="data lh-22 fn fs-12 c-7">
                      {{ item.create_time }}
                    </div>
                  </div>
                  <div class="fs-12 lh-22 mt-8">
                    <span class="c-7">
                      {{ $t('基于') }}
                      <template v-if="item.compose_type === 10">{{ $t('帖子') }}</template>
                      <template v-else-if="item.compose_type === 20">{{ $t('文章') }}</template>
                      <template v-else-if="item.compose_type === 30">{{ $t('活动') }}</template>
                    </span>
                    <span style="color: #0067D1;" class="ml-6 cup" @click="handleLink(item)">{{ item.title }}</span>
                  </div>
                  <div v-html="item.parent.content" class="desc fs-14 c-16 lh-20 mt-8">
                  </div>
                  <!-- 二级 -->
                  <div class="list">
                    <div class="mt-20 df aic jcsb">
                      <div class="">
                        <img :src="userData.tesa_personal_photo_arr" class="avatar mb-2" alt="">
                        <span class="name ml-6">{{ item.user_name }}</span>
                        <span class="d1 ml-6 break-word">{{ $t('回复') }}</span>
                        <span class="name ml-6">
                          <template v-if="item.parent.ans_type == 20">
                            {{ $t('匿名用户') }}
                          </template>
                          <template v-else>
                            {{ item.parent.is_expert == 10 ? item.parent.user_name : item.parent.user_nick_name }}
                          </template>
                        </span>
                      </div>

                    </div>
                    <div v-html="item.content" class="desc fs-14 c-16 lh-20 mt-8">
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="no-data">
                  <img src="@/assets/images/empty_data.png" alt="">
                  <p>{{ $t('暂无数据') }}</p>
                </div>
              </template>

            </div>

          </div>
          <!-- 平台 -->
          <div class="card3 mt-16">
            <div class="t1 pb-5">{{ is_expert ? $t('我的平台') : $t('TA的平台') }}</div>
            <template v-if="promotion_detail && promotion_detail.length">
              <div class=" mt-23 df aife" v-for="(item, index) in promotion_detail" :key="index">
                <img :src="item.tesra_qr_code_arr" class="img" alt="">
                <div class="ml-20">
                  <p class="p1">{{ item.tesra_type_name }}</p>
                  <p class="p2">{{ item.tesra_name }}</p>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="no-data">
                <img src="@/assets/images/empty_data.png" style="width: auto;" alt="">
                <div v-if="userData.tesa_status === 20 && is_expert" @click="handleOpen">
                  <el-button class="btn1">+{{ $t('上传宣传账号') }}</el-button>
                </div>
                <div v-else>
                  <p>{{ $t('暂无数据') }}</p>
                </div>
              </div>
            </template>
          </div>
          <posterModel ref="posterDialog" :promotion_detail="promotion_detail" :data="data_list"
            @poster-submitted="handleposterSubmitted" @clearPromotion="getData()"></posterModel>
        </div>

        <div class="right-box ml-16">
          <div class="info-box df aic">
            <img :src="expertType == 10 ? userData.tesa_personal_photo_arr : userData.tesa_personal_photo_mvp_arr" class="avatar" alt="" @click="(event) => handleaAvatar(event, userData)">
            <div class="ml-40 mr-24 f1 over-h">
              <div class="name df aic">
                {{ userData.tesa_name }}
                <template v-if="expertType == 10">
                  <span class="name-expert ml-8">{{ $t('驻站专家') }}</span>
                </template>
                <template v-if="expertType == 20">
                  <span class="name-expert mvpname-expert ml-8">{{ $t('MVP') }}</span>
                </template>
              </div>
              <div class="c">
                <template v-if="userData.tesa_company_show == 10">
                  {{ userData.tesa_company }}
                </template>
                {{ userData.user_job_name }}
              </div>
              <div class="d1 df over-h">
                <span class="s1">{{ $t('专注领域') }}</span>
                <div class="tow-text">
                  <span class="s2" v-for="(items1, index1) in userData.user_excel_arr" :key="index1">
                    {{ items1.label }}<span v-if="index1 < userData.user_excel_arr.length - 1">、</span>
                  </span>
                </div>
              </div>
              <div class="d1">
                <span class="s1">{{ $t('个人ID') }}</span>
                <span class="s2">{{ userData.user_nick_name }}</span>
              </div>
            </div>

            <template v-if="!is_expert">
              <el-button class="btn" @click="userfollowAdd()">{{ userData.have_be_follow == 10 ? $t('已关注') : $t('关注TA')
                }}</el-button>
            </template>
          </div>
          <template v-if="tag_id === 10">
            <div class="right-list">
              <div class="t1">{{ is_expert ? $t('我的创作') : $t('TA的代表作') }}</div>
              <div class="tab df">
                <span v-for="(item, index) in compose_tabs" :key="index"
                  :class="{ active: composeActiveTab === item.value }" @click="setComposeActiveTab(item.value)">
                  {{ $t(item.label) }}
                </span>
              </div>
              <!-- 全部 -->
              <template v-if="articles.length">
                <template class="mt-10">
                  <div v-if="composeActiveTab == 10" class="bottom-border">
                    <div v-for="(item, index) in articles" :key="index" @click="handleArticleLink(item)">
                      <div class="list cup" :class="{ refined: index === 0, hot: index === 1 }">
                        <div class="tit1 pr-56">
                          <span v-if="index < 2" :class="{ refined: index === 0, hot: index === 1 }">
                            {{ index === 0 ? $t('精') : index === 1 ? $t('热') : '' }}
                          </span>
                          {{ item.title }}
                        </div>
                        <div class="desc">
                          {{ item.article_desc }}
                        </div>
                        <div class="df aic jcsb">
                          <div class="type" v-if="item.user_excel_arr">
                            <span v-for="(items1, index1) in item.user_excel_arr" :key="index1">{{ items1.label
                              }}</span>
                          </div>

                          <div class="dates df fn">
                            <div class="comment-list df">
                              <div class="li">
                                <span class="iconfont">&#xe611;</span>
                                <span class="text">{{ item.hits }}</span>
                              </div>
                              <div class="li">
                                <span class="iconfont">&#xe61b;</span>
                                <span class="text">{{ item.likes }}</span>
                              </div>
                              <div class="li">
                                <span class="iconfont">&#xe63e;</span>
                                <span class="text">{{ item.reply_count }}</span>
                              </div>
                            </div>
                            <span class="date">{{ item.create_time }}</span>
                          </div>
                        </div>
                        <img v-if="index === 0" :src="require('../../assets/images/essence.png')" class="essence"
                          alt="精">
                        <img v-if="index === 1" :src="require('../../assets/images/hot.png')" class="essence" alt="热">
                      </div>
                    </div>

                  </div>
                  <div v-if="composeActiveTab == 20" class="bottom-border">
                    <template v-if="topicArticles.length">
                      <div v-for="(item, index) in topicArticles" :key="index" @click="handleArticleLink(item)">
                        <div class="list cup" :class="{ refined: index === 0, hot: index === 1 }">
                          <div class="tit1 pr-56">
                            <span v-if="index < 2" :class="{ refined: index === 0, hot: index === 1 }">
                              {{ index === 0 ? $t('精') : index === 1 ? $t('热') : '' }}
                            </span>
                            {{ item.title }}
                          </div>
                          <div class="desc">
                            {{ item.article_desc }}
                          </div>
                          <div class="df aic jcsb">
                            <div class="type" v-if="item.user_excel_arr">
                              <span v-for="(items1, index1) in item.user_excel_arr" :key="index1">{{ items1.label
                                }}</span>
                            </div>

                            <div class="dates df fn">
                              <div class="comment-list df">
                                <div class="li">
                                  <span class="iconfont">&#xe611;</span>
                                  <span class="text">{{ item.hits }}</span>
                                </div>
                                <div class="li">
                                  <span class="iconfont">&#xe61b;</span>
                                  <span class="text">{{ item.likes }}</span>
                                </div>
                                <div class="li">
                                  <span class="iconfont">&#xe63e;</span>
                                  <span class="text">{{ item.reply_count }}</span>
                                </div>
                              </div>
                              <span class="date">{{ item.create_time }}</span>
                            </div>
                          </div>
                          <img v-if="index === 0" :src="require('../../assets/images/essence.png')" class="essence"
                            alt="精">
                          <img v-if="index === 1" :src="require('../../assets/images/hot.png')" class="essence" alt="热">
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="no-data">
                        <img src="@/assets/images/empty_data.png" alt="">
                        <p>{{ $t('暂无数据') }}</p>
                      </div>
                    </template>

                  </div>
                  <div v-if="composeActiveTab == 30" class="bottom-border">
                    <template v-if="posts.length">
                      <div v-for="(item, index) in posts" :key="index" @click="handleArticleLink(item)">
                        <div class="list cup" :class="{ refined: index === 0, hot: index === 1 }">
                          <div class="tit1 pr-56">
                            <span v-if="index < 2" :class="{ refined: index === 0, hot: index === 1 }">
                              {{ index === 0 ? $t('精') : index === 1 ? $t('热') : '' }}
                            </span>
                            {{ item.title }}
                          </div>
                          <div class="desc">
                            {{ item.article_desc }}
                          </div>
                          <div class="df aic jcsb">
                            <div class="type" v-if="item.user_excel_arr">
                              <span v-for="(items1, index1) in item.user_excel_arr" :key="index1">{{ items1.label
                                }}</span>
                            </div>

                            <div class="dates df fn">
                              <div class="comment-list df">
                                <div class="li">
                                  <span class="iconfont">&#xe611;</span>
                                  <span class="text">{{ item.hits }}</span>
                                </div>
                                <div class="li">
                                  <span class="iconfont">&#xe61b;</span>
                                  <span class="text">{{ item.likes }}</span>
                                </div>
                                <div class="li">
                                  <span class="iconfont">&#xe63e;</span>
                                  <span class="text">{{ item.reply_count }}</span>
                                </div>
                              </div>
                              <span class="date">{{ item.create_time }}</span>
                            </div>
                          </div>
                          <img v-if="index === 0" :src="require('../../assets/images/essence.png')" class="essence"
                            alt="精">
                          <img v-if="index === 1" :src="require('../../assets/images/hot.png')" class="essence" alt="热">
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="no-data">
                        <img src="@/assets/images/empty_data.png" alt="">
                        <p>{{ $t('暂无数据') }}</p>
                      </div>
                    </template>

                  </div>
                </template>
              </template>
              <template v-else>
                <div class="no-data">
                  <img src="@/assets/images/empty_data.png" alt="">
                  <p>{{ $t('暂无数据') }}</p>
                </div>
              </template>
            </div>
          </template>
          <template v-else-if="tag_id === 30">
            <achievement></achievement>
          </template>
          <template v-else-if="tag_id === 50">
            <interaction></interaction>
          </template>
          <template v-else-if="tag_id === 60">
            <apply @clearPromotion="getData()" @addPromotion="getData()"></apply>
          </template>
          <template v-else>
            <div class="no-data">
              <img src="@/assets/images/empty_data.png" alt="">
              <p>{{ $t('暂无数据') }}</p>
            </div>
          </template>


        </div>
      </div>

    </div>

    <!-- 个人信息 -->
        <avatarTop ref="avatarDialog" @post-submitted="handleAvatarSubmitted" :id="id" />
  </div>
</template>

<script>
import interaction from "./components/interaction.vue";
import achievement from "./components/achievement.vue";


import apply from "./components/apply.vue";

import { getMyInfo, setuserfollowAdd } from "@api/home";
import {
  getExpertInfo,
  getExpertCompose,
  getReplyList,
  promotionDetail,
  getPostList,
  getArticleList,
  commonData, addPromotion
} from "@api/expert";
import posterModel from "@comp/posterModel.vue";

export default {
  components: { posterModel, interaction, apply, achievement },
  data() {
    return {
      id: 0,
      user_id: 0,
      currLanguage: 'cn',
      userinfo: [],
      curr_user_data: [],
      is_expert: false,
      tag_id: 10,
      userData: [],
      articles: [],
      replyList: [],
      posts: [],
      topicArticles: [],
      promotion_detail: [],
      pagination: {
        page: 1,
        total: 0,

      },
      data_list: {},
      activeTab: 10, // 默认选中的 tab 值
      tabs: [
        { value: 10, label: '我的创作', icon: "icon-a-svg1" },
        { value: 20, label: '我的收藏', icon: "icon-svg" },
        { value: 30, label: '我的成就', icon: "icon-a-svg2" },
        { value: 40, label: '我的关注', icon: "icon-pengyou" },
        { value: 50, label: '我的互动', icon: "icon-a-xingzhuangjiehe3" },
        { value: 60, label: '我的申请', icon: "icon-a-xingzhuangjiehe4" },
        { value: 70, label: '账号及资料', icon: "icon-a-xingzhuangjiehe5" },
      ],
      composeActiveTab: 10, // 默认选中的 tab 值
      expertType: 10, // 从驻站专家进入还是mvp进入
      compose_tabs: [
        { value: 10, label: '全部' },
        { value: 20, label: '文章' },
        { value: 30, label: '帖子' },
      ],
      FormData: {},
      defaultAvatar: 'https://www.oceanclub.org/static/protal/images/avatar-default.png',
    }
  },
  computed: {
    userId() {
      return this.$route.params.id; // 获取路由参数
    },
  },
  created() {
    this.setActiveTab(parseInt(this.$route.params.tab));
    this.setExpertType(parseInt(this.$route.params.type));
  },
  mounted() {
    // 设置默认的顶部菜单背景色
    this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 1);');
    this.getData();
    this.getExpertCompose();
    this.getCurrUserData();
    this.getReplyList();
    let Language = localStorage.getItem('currentLanguage'); // 获取本地语言
    this.currLanguage = Language && Language !== 'zh';
  },
  methods: {
    async handleposterSubmitted(content) {
      let res = await addPromotion({ content: content });
      if (res.status == 200) {
        this.$message.success(res.msg);
        this.getData();
      }
    },
    async getCommon() {
      let res = await commonData();
      if (res.status == 200) {
        this.data_list = res.data;
      }
      this.$refs.posterDialog.openModal();
    },
    handleOpen() {
      this.getCommon();
    },

    handleLinks(str) {
      let path = '/cn';

      let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      if (Language && Language != 'zh') {
        path = '/' + Language;
      }
      this.$router.push(path + str); //活动
    },
    handleLink(item) {
      let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      let str = "/protal";
      if (Language && Language != 'zh') {
        str = "/protal_" + Language;
      }
      if (item.compose_type == 10) {
        // const url = str + '/post/info/id/' + item.tp_id; //帖子
        // window.open(url, '_blank');
        this.$navigate('/discuss/info', item.tp_id)
      } else if (item.compose_type == 20) {
        // const url = str + '/topicarticle/info/id/' + item.ttar_id; //文章
        // window.open(url, '_blank');
        this.$navigate('/subject/info', item.ttar_id)
      } else if (item.compose_type == 30) {
        let str = '/cn';
        if (Language && Language != 'zh') {
          str = '/' + Language;
        }
        // this.$router.push(str + '/activity/info/' + item.ta_id); //活动
        const target = this.$router.resolve(str + '/activity/info/' + item.ta_id)
        window.open(target.href, '_blank');
      }
    },
    handleArticleLink(item) {
      let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      let str = "/protal";
      if (Language && Language != 'zh') {
        str = "/protal_" + Language;
      }
      if (item.compose_type == 10) {
        // const url = str + '/post/info/id/' + item.id; //帖子
        // window.open(url, '_blank');
        this.$navigate('/discuss/info', item.id)
      } else if (item.compose_type == 20) {
        // const url = str + '/topicarticle/info/id/' + item.id; //文章
        // window.open(url, '_blank');
        this.$navigate('/subject/info', item.id)
      }
    },
    setExpertType(type){
      this.expertType = type;
    },
    async setActiveTab(value) {
      this.activeTab = value; // 设置当前选中的 tab 值
      this.tag_id = value;
      // 根据 activeTab 的值调用不同的接口
      switch (value) {
        case 10:
          await this.getExpertCompose();
          break;
        case 20:
          // await getMyFavorites();
          break;
        case 30:
          // await getMyAchievements();
          break;
        case 40:
          // await getMyFollows();
          break;
        case 50:
          break;
        case 60:
          break;
        case 70:
          // await getAccountInfo();
          break;
        default:
          await this.getExpertCompose();
          break;
      }
    },
    async setComposeActiveTab(value) {
      this.composeActiveTab = value; // 设置当前选中的 tab 值
      // 根据 activeTab 的值调用不同的接口
      switch (value) {
        case 10:
          await this.getExpertCompose();
          break;
        case 20:
          await this.getArticleList();
          break;
        case 30:
          await this.getPostList();
          break;
        default:
          await this.getExpertCompose();
          break;
      }
    },
    async getExpertCompose() {
      let res = await getExpertCompose({ user_id: this.userId });
      if (res.status == 200) {
        this.articles = res.data;
      }
      return [];
    },
    async getReplyList() {
      let res = await getReplyList({ user_id: this.userId });
      if (res.status == 200) {
        this.replyList = res.data;
      }
      return [];
    },
    async getPostList() {
      let res = await getPostList({ user_id: this.userId });
      if (res.status == 200) {
        this.posts = res.data;
      }
      return [];
    },
    async getArticleList() {
      let res = await getArticleList({ user_id: this.userId });
      if (res.status == 200) {
        this.topicArticles = res.data;
      }
      return [];
    },
    async getCurrUserData() {
      let res = await getMyInfo();
      if (res.status == 200) {
        this.userinfo = res.data;
        if (this.userinfo.user_id == this.userId) {
          this.is_expert = true;
        }
      }
    },

    handleaAvatar(event, item) {
      event.stopPropagation(); // 阻止事件冒泡
      this.$refs.avatarDialog.openModal();
      this.id = item.user_id;
    },
    async handleAvatarSubmitted(id) {

      let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
      if (res.status == 200) {
        this.$message.success(res.msg);

      }

    },

    async userfollowAdd() {
      let res = await setuserfollowAdd({ tuf_be_follow_user_id: this.userId });
      if (res.status === 200) {
        this.$message.success(res.msg);
        this.getData();
      }
    },

    // 初始化获取数据
    async getData() {
      const res = await getExpertInfo({
        user_id: this.userId,
        expertType:this.expertType
      });
      if (res.status == 200) {
        this.userData = res.data;
      }
      const promotion_detail = await promotionDetail({ user_id: this.userId });
      if (promotion_detail.status == 200) {
        this.promotion_detail = promotion_detail.data;
      }

    },
  }


}
</script>

<style lang="scss" scoped>
.no-data {
  .btn1 {
    width: 108px;
    height: 28px;

    border: 0.5px solid rgb(174, 174, 174);
    border-radius: 30px;

    color: rgb(25, 25, 25);
    font-family: "harmonyos";
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    padding: 0 6px;
    margin-top: 13px;

    &:hover {
      color: #D80F05;
      border: 0.5px solid #D80F05;
      background: transparent;
    }

  }
}

.imglist {
  img {
    max-height: 46px;
    margin-right: 4px;
  }
}

.card-tab {
  width: 325px;
  border: 1px solid rgb(243, 243, 243);
  border-radius: 8px;
  /* shadow-l */
  box-shadow: -2px 0px 12px 0px rgba(0, 0, 0, 0.08);
  background: rgb(255, 255, 255);
  padding: 13px 20px;
  margin-top: 16px;

  .li {
    border-radius: 8px;
    padding: 13px 8px 13px 12px;
    margin-bottom: 8px;
    cursor: pointer;

    &.active,
    &:hover {
      background: rgb(252, 244, 243);

      span,
      .iconfotn {
        color: #D80F05;
      }
    }

    .iconfont {
      font-size: 17px;
      color: #191919;
      margin-right: 13px;
    }

    span {
      color: rgb(25, 25, 25);
      font-family: "harmonyos";
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.interaction-box {

  .avatar {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    object-fit: cover;
  }

  .list {
    &>.list {
      padding-left: 16px;
    }
  }

  .name {
    color: #191919;
    font-family: "MicrosoftYaHeiSemibold";
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;


  }

  .d1 {
    color: #777777;
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;
  }
}

.right-list {

  .list {
    padding: 16px;
    border-bottom: 1px solid #EAEAEA;
    position: relative;
    transition: border-bottom 0.36s;


    &:hover {
      border-bottom: 1px solid #D80F05;

      .tit1 {
        color: #D80F05;
      }

    }

    .essence {
      position: absolute;
      top: 15px;
      right: 39px;
    }

    &.refined::after {
      content: "";
      display: block;
      width: 400px;
      height: calc(100% + 1px);
      opacity: 0.6;
      position: absolute;
      right: -24px;
      top: 0;
      background: linear-gradient(-64.32deg, rgba(255, 0, 0, 0.11) -2.454%, rgba(196, 196, 196, 0) 96.835%);
    }

    &.hot::after {
      content: "";
      display: block;
      width: 400px;
      height: calc(100% + 1px);
      opacity: 0.6;
      position: absolute;
      right: -24px;
      top: 0;
      background: linear-gradient(-64.32deg, rgba(254, 190, 8, 0.21) -2.457%, rgba(196, 196, 196, 0) 96.875%);
    }

    // &:last-child {
    //   border-bottom: none;
    // }

    .tit1 {
      color: rgb(25, 25, 25);
      font-family: "MicrosoftYaHeiSemibold";
      font-size: 18px;
      font-weight: 400;
      line-height: 24px;

      span {
        text-align: center;
        line-height: 18px;
        display: inline-block;
        min-width: 18px;
        height: 18px;
        font-size: 14px;
        color: #ffffff;
        border-radius: 2px;
        position: relative;
        top: -2px;
        margin-right: 2px;
        padding: 0 2px;
      }

      .refined {

        background: rgb(215, 17, 17);

      }

      .hot {
        background: #FF6E00;
      }
    }

    .desc {
      color: rgb(51, 51, 51);
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      margin-top: 10px;
    }

    .type {
      span {
        display: inline-block;
        height: 22px;
        background-color: #F0F1F1;
        border-radius: 4px;
        padding: 0 4px;
        color: #868D9F;
        line-height: 22px;
        font-size: 12px;
        margin-right: 6px;
      }
    }

    .dates {
      height: 29px;
      line-height: 29px;
      margin-top: 8px;

      .date {
        font-size: 14px;
        color: #868D9F;
        position: relative;
        padding-left: 16px;

        &::after {
          content: "";
          display: inline-block;
          height: 12px;
          width: 1px;
          background-color: #D8D8D8;
          position: absolute;
          left: 0;
          top: 50%;
          margin-top: -6px;
        }
      }

      .comment-list {
        .li {
          color: #868D9F;
          font-size: 14px;
          margin-right: 15px;

          .iconfont {
            margin-right: 5px;
          }

          .text {}
        }
      }
    }

  }

  .tab {
    color: rgb(25, 25, 25);
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
    margin-top: 20px;
    padding-left: 16px;

    span {
      margin-right: 18px;
      cursor: pointer;
      padding: 0 2px;
      transition: all 0.1s;
    }

    span:hover {
      color: rgb(25, 25, 25);
      font-size: 17px;
      font-family: "MicrosoftYaHeiSemibold";
      padding: 0 0px;
    }

    .active {
      font-family: "MicrosoftYaHeiSemibold";
      font-size: 17px;
      color: rgb(25, 25, 25);
      border-bottom: 2px solid #D80F05;
      padding: 0 0px;
    }
  }

}

.bread {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  padding: 8px 0 11px;
  color: #939393;

  .active {
    color: #191919;
  }
}

.left-box {
  width: 325px;

  .card1 {
    width: 325px;
    min-height: 374px;
    border: 1px solid rgb(243, 243, 243);
    border-radius: 8px;
    box-shadow: -2px 0px 12px 0px rgba(101, 41, 41, 0.08);
    background-image: url('../../assets/images/img/card.png');
    background-repeat: no-repeat;
    padding-top: 269px;
    padding-bottom: 24px;
    position: relative;

    .level-boxs {
      color: #ffffff;
      position: absolute;
      font-size: 48px;
      font-family: "montserrat";
      font-size: 48px;
      font-weight: 700;
      line-height: 48px;
      width: 100%;
      text-align: center;
      left: 0;
      top: 88px;
    }

    .t1 {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0px;
      color: #191919;

      .s1 {
        color: #A83328;
      }

      .s2 {
        color: #285F9F;
      }
    }

    .t2 {
      color: rgb(25, 25, 25);

      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
    }
  }

  .card2 {
    width: 325px;
    border: 1px solid rgb(243, 243, 243);
    border-radius: 8px;
    /* shadow-l */
    box-shadow: -2px 0px 12px 0px rgba(0, 0, 0, 0.08);
    background: rgb(255, 255, 255);
    margin-top: 16px;
    padding: 24px;

    .t1 {
      color: rgb(25, 25, 25);
      font-family: "MicrosoftYaHeiSemibold";
      font-size: 20px;
      font-weight: 400;
      line-height: 24px;
    }
  }

  .card3 {
    width: 325px;
    border: 1px solid rgb(243, 243, 243);
    border-radius: 8px;
    /* shadow-l */
    box-shadow: -2px 0px 12px 0px rgba(0, 0, 0, 0.08);
    background: rgb(255, 255, 255);
    padding: 24px 28px;

    .t1 {
      color: rgb(25, 25, 25);
      font-family: "MicrosoftYaHeiSemibold";
      font-size: 20px;
      font-weight: 400;
      line-height: 24px;
    }

    .img {
      width: 64px;
      height: 64px;
      object-fit: cover;
    }

    .p1 {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #8C8C8C;
    }

    .p2 {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
    }
  }
}

.right-box {
  width: calc(100% - 341px);

  .info-box {
    height: 209px;
    border: 1px solid rgb(243, 243, 243);
    border-radius: 8px;
    /* shadow-l */
    box-shadow: -2px 0px 12px 0px rgba(0, 0, 0, 0.08);
    background: rgb(255, 255, 255);
    padding: 0 46px;

    .avatar {
      width: 123px;
      height: 123px;
      border-radius: 50%;
      object-fit: cover;
    }

    .name {
      color: rgb(18, 18, 18);
      font-family: "MicrosoftYaHeiSemibold";
      font-size: 22px;
      font-weight: 400;
      line-height: 28px;

      .name-expert {
        height: 18px;
        line-height: 18px;
        background-color: #D80F05;
        border-radius: 4px;
        color: #ffffff;
        font-size: 12px;
        padding: 0 6px;
      }

      .name-expert.mvpname-expert{
   
        background-color: #FF7700;
       
      }
    }

    .c {
      color: rgb(18, 18, 18);
      font-family: "MicrosoftYaHeiSemibold";
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      margin-top: 8px;
    }

    .d1 {

      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      margin-top: 8px;

      .s1 {
        display: inline-block;
        min-width: 66px;
        margin-right: 10px;
        color: rgb(119, 119, 119);
      }

      .s2 {
        color: rgb(18, 18, 18);
        margin-right: 10px;

        &:first-child {
          margin-left: 0;
        }
      }


    }

    .btn {
      font-size: 14px;
      width: 98px;
      padding: 0 16px;
      color: rgb(0, 0, 0);
      height: 36px;
      border: 1px solid rgb(0, 0, 0);
      border-radius: 23px;
      background: #ffffff;
      background-color: #ffffff;

      &:hover {
        color: #D80F05;
        border: 1px solid #D80F05;
      }
    }
  }

  .right-list {
    padding: 24px;
    border: 1px solid rgb(243, 243, 243);
    border-radius: 8px;
    /* shadow-l */
    box-shadow: -2px 0px 12px 0px rgba(0, 0, 0, 0.08);
    background: rgb(255, 255, 255);
    margin-top: 16px;

    .t1 {
      color: rgb(25, 25, 25);
      font-family: "MicrosoftYaHeiSemibold";
      font-size: 20px;
      font-weight: 400;
      line-height: 24px;
      padding-left: 16px;
    }
  }
}

.bottom-border {
  &>div:last-child {
    .list {
      border-bottom: none;

    }
  }
}
</style>